// extracted by mini-css-extract-plugin
module.exports = {"DropZoneLabel":"YCpK4j2DSrqzH2lgeoSbsA==","Select":"oDZNigE8SzIRLAVHv-Zfcg==","DropZoneSelect":"SLB41reCTrUoinqCoUYnug=="};